import { AssinaturaType } from '../../../../_metronic/helpers'
import { getCompanyLoginPathById } from './loginCompanyConfig'

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'
const LOCAL_STORAGE_TIPO_CERTIFICADO = 'assinatura.tipo'
const LOGIN_REDIRECT_STORAGE_KEY = 'auth.login.redirect'
const LOGIN_EMPRESA_STORAGE_KEY = 'auth.login.empresa'
const DEFAULT_LOGIN_REDIRECT = '/auth/login'

export const loadLoginEmpresaId = (): number | undefined => {
  const empresaId = localStorage.getItem(LOGIN_EMPRESA_STORAGE_KEY)

  return empresaId ? Number(empresaId) : undefined
}

export const saveLoginEmpresaId = (empresaId?: number) => {
  if (!empresaId) {
    localStorage.removeItem(LOGIN_EMPRESA_STORAGE_KEY)
    return
  }

  localStorage.setItem(LOGIN_EMPRESA_STORAGE_KEY, String(empresaId))
}

export const clearLoginEmpresaId = () => {
  localStorage.removeItem(LOGIN_EMPRESA_STORAGE_KEY)
}

export const loadTipoCert = () => {
  return localStorage.getItem(LOCAL_STORAGE_TIPO_CERTIFICADO) as AssinaturaType | null
}

export const clearTipoCert = () => {
  localStorage.removeItem(LOCAL_STORAGE_TIPO_CERTIFICADO)
}

export const saveTipoCert = (tipo: AssinaturaType) => {
  localStorage.setItem(LOCAL_STORAGE_TIPO_CERTIFICADO, tipo)
}

const getLoginRedirectPath = (): string => {
  if (!localStorage) return DEFAULT_LOGIN_REDIRECT

  const redirectPath = localStorage.getItem(LOGIN_REDIRECT_STORAGE_KEY) || DEFAULT_LOGIN_REDIRECT
  const oldIdPathMatch = redirectPath.match(/^\/auth\/login\/([^/]+)\/?$/)

  return getCompanyLoginPathById(oldIdPathMatch?.[1]) || redirectPath
}

const saveLoginRedirectPath = (redirectPath = DEFAULT_LOGIN_REDIRECT) => {
  if (!localStorage) return

  localStorage.setItem(LOGIN_REDIRECT_STORAGE_KEY, redirectPath)
}

export function setupAxios(axios: any) {
  axios.defaults.headers.Accept = 'application/json'
  axios.defaults.withCredentials = true
}

export { getLoginRedirectPath, saveLoginRedirectPath, AUTH_LOCAL_STORAGE_KEY }
